export default function () {
    return {
        localData: {
            indexDbId: null,
            products: [],
            favourites: [],
            drugstoreId: [],
        },
    };
}
